import { render, staticRenderFns } from "./DetailItems.vue?vue&type=template&id=18155ed1&"
import script from "./DetailItems.vue?vue&type=script&lang=js&"
export * from "./DetailItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports